module.exports = __webpack_public_path__ + "static/media/HCMM507.813082f9.jpg";